import script from "./XTitleLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./XTitleLabel.vue?vue&type=script&lang=ts&setup=true"

import "./XTitleLabel.vue?vue&type=style&index=0&id=9060faf2&lang=css&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9060faf2"]])

export default __exports__